import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import { InputWrapper, LabelDataHeading, ContentDivider, CheckboxLabel } from '../../style';
import { CardContainer, CardDataHeadingValue, GrantAllocationSwitch } from '../RenderCard/style';
import CurrencyInput from "../../../../../../CommonComponents/CurrencyInput/CurrencyInput";
import { formatAmount } from '../../../../../../utils/commonUtil';
import PercentageInput from '../../../../../../CommonComponents/PercentageInput/PercentageInput';
import { CustomCheckbox, DisplayFlex } from '../../../../../../CommonComponents/commonStyles';
import { replaceSelect } from "../../../../../../utils/replacer"

export default class GrantAllocationCard extends Component {
  render() {
    const {
      grantAllocation,
      onGrantAmountChange,
      onGrantPercentageChange,
      checkAmountLimits,
      allocType,
      allocationPreference,
      allSharesAllPoolsCheck,
      allSharesCheck,
      onAllShareChange,
      scheduleType,
      showAllSharesColumn,
      disableAllInputs,
      rowCheked
    } = this.props;

    return (
      grantAllocation.map((data, index) => {
        return (
          <CardContainer key={data.id} index={index}>
            {
              allocationPreference === "entireBalance" ? 
                <Row>
                  <Col span={12}>
                    <DisplayFlex>
                    <GrantAllocationSwitch
                      className="mobile-switch"
                      onChange={(checked) => onAllShareChange({ target: {checked: checked} }, data)}
                      checked={data.allShare}
                      disabled={rowCheked || allSharesAllPoolsCheck || disableAllInputs}
                    /> 
                    <LabelDataHeading className="ml-10">Allocate</LabelDataHeading>
                    </DisplayFlex>                  
                  </Col>
                  <Col span={12}>
                    <CardDataHeadingValue className="mb-20">{replaceSelect(data.name)}</CardDataHeadingValue>
                  </Col>
                </Row>
              : <CardDataHeadingValue className="mb-20">{replaceSelect(data.name)}</CardDataHeadingValue>
            }
            <Row>
              <Col span={12}>
                <LabelDataHeading>Available Balance</LabelDataHeading>
                <CardDataHeadingValue>{formatAmount(data.availableBalance)}</CardDataHeadingValue>
              </Col>
              <Col span={12}>
                <LabelDataHeading>Account Allocation**</LabelDataHeading>
                <CardDataHeadingValue>{data.percentShare}%</CardDataHeadingValue>
              </Col>
            </Row>
            <ContentDivider />
            <Row>
              {
                allocationPreference !== "entireBalance" &&
                  <Col span={12}>
                  <LabelDataHeading>Grant Percentage</LabelDataHeading>
                    <InputWrapper className="mr2">
                      <PercentageInput
                        id={"txtGrantPercentageCard"+data.id}
                        label="grant-percentage"
                        maxLength={150}
                        onChange={e => onGrantPercentageChange(e, data,allocationPreference)}
                        value={data.grantPercentage}
                        onBlur={() => checkAmountLimits(data)}
                        aria-label="Percentage"
                        role="textbox"
                      />
                    </InputWrapper>
                  </Col>
              }
              <Col span={12}>
                <LabelDataHeading>Grant Amount</LabelDataHeading>
                <InputWrapper>
                  <CurrencyInput
                    id={"txtGrantAmountCard"+data.id}
                    label="grant-amount"
                    maxLength={150}
                    onChange={e => onGrantAmountChange(e, data,allocationPreference)}
                    value={data.grantAmount}
                    aria-label="GrantAmount"
                    role="textbox"
                    onBlur={() => checkAmountLimits(data)}
                    disabled={
                      allocType === "entireBalance"
                      || allSharesAllPoolsCheck
                      || allSharesCheck
                      || disableAllInputs
                    }
                  />
                </InputWrapper>
              </Col>
            </Row>
            
          </CardContainer>);
      })

    )
  }
}

GrantAllocationCard.propTypes = {
  allSharesAllPoolsCheck: PropTypes.bool,
  allSharesCheck: PropTypes.bool,
  allocType: PropTypes.string,
  allocationPreference: PropTypes.string,
  checkAmountLimits: PropTypes.func,
  disableAllInputs: PropTypes.bool,
  grantAllocation: PropTypes.arrayOf(
    PropTypes.shape({
      allShare: PropTypes.bool,
      availableBalance: PropTypes.number,
      grantAmount: PropTypes.string,
      grantPercentage: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      percentShare: PropTypes.number,
      units: PropTypes.number
    })
  ),
  onAllShareAllPoolsChange: PropTypes.func,
  onAllShareChange: PropTypes.func,
  onGrantAmountChange: PropTypes.func,
  onGrantPercentageChange: PropTypes.func,
  scheduleType: PropTypes.string,
  showAllSharesColumn: PropTypes.bool,
}
